import { useQuery } from '@apollo/client';
import LoadingPageIndicator from '@base/components/LoadingPageIndicator';
import PageLoadError from '@base/components/PageLoadError';
import { isPublicVHPlayerPage } from '@base/utility/VirtualHumanUtility';
import PDWebPlayerPageContent from '@core/components/VirtualHumans/PDWebPlayerContent/PDWebPlayerPageContent';
import { READ_VIRTUAL_HUMAN_FOR_PLAYER } from '@core/components/VirtualHumans/PDWebPlayerContent/PDWebPlayerPageContent.query';
import usePublicToken from '@core/helpers/usePublicToken';
import useUser from '@core/helpers/useUser';
import { useStateUrl } from '@virtidev/toolbox';
import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export const PDWebPlayerEmbedContent = () => {
  const { ssVirtualHumanID: id } = useParams();
  const location = useLocation();
  const { value: sharetoken } = useStateUrl({ key: 'sharetoken' });
  const { value: publicPlayer } = useStateUrl({ key: 'publicPlayer' });
  const skip = !isPublicVHPlayerPage(location);
  const {
    data: publicData,
    error: publicError,
    loading: publicLoading,
    called,
  } = usePublicToken({
    skip,
  });

  const { data, loading, error } = useQuery(READ_VIRTUAL_HUMAN_FOR_PLAYER, {
    variables: {
      sharetokenHeader: sharetoken,
      filter: { ID: { eq: id } },
    },
  });

  if ((!skip && publicLoading) || loading) {
    return <LoadingPageIndicator />;
  }
  if (publicError || error) {
    return <PageLoadError graphQLErrorObj={publicError || error} />;
  }

  if (!skip && (!called || !publicData)) {
    return null;
  }

  return (
    <PDWebPlayerPageContent
      user={publicData?.createPublicToken?.Member}
      data={data}
      loading={loading}
      error={error}
      sharetoken={sharetoken}
      isEmbedded={publicPlayer === 'true'}
    />
  );
};

export default PDWebPlayerEmbedContent;
